export default function CamaraIcon ({ className = 'h-6 w-6', color }) {
  return(
    <svg
    className={className}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 18C14.7614 18 17 15.7614 17 13C17 10.2386 14.7614 8 12 8C9.23858 8 7 10.2386 7 13C7 15.7614 9.23858 18 12 18Z'
        stroke={color}
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
        />
      <path
        d='M21 22H3C2.46957 22 1.96086 21.7893 1.58579 21.4142C1.21071 21.0391 1 20.5304 1 20V7C1 6.46957 1.21071 5.96086 1.58579 5.58579C1.96086 5.21071 2.46957 5 3 5H7L9 2H15L17 5H21C21.5304 5 22.0391 5.21071 22.4142 5.58579C22.7893 5.96086 23 6.46957 23 7V20C23 20.5304 22.7893 21.0391 22.4142 21.4142C22.0391 21.7893 21.5304 22 21 22Z'
        stroke={color}
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
        />
      <path
        d='M4 9C4.55228 9 5 8.55228 5 8C5 7.44772 4.55228 7 4 7C3.44772 7 3 7.44772 3 8C3 8.55228 3.44772 9 4 9Z'
        fill='#442E83'
        />
    </svg>

  )
}